import {
  Cake, Gift, Star, Heart, Briefcase, Award, Trophy, Sparkles, Crown, Gem, PartyPopper,
  Coffee, Music, Dumbbell, BookOpen, Users, CalendarDays, Megaphone, Flag, Zap, Flame,
  LucideIcon
} from 'lucide-react';

export const EVENT_ICON_OPTIONS: { value: string; label: string; icon: LucideIcon }[] = [
  { value: 'cake', label: 'Cake', icon: Cake },
  { value: 'gift', label: 'Gift', icon: Gift },
  { value: 'star', label: 'Star', icon: Star },
  { value: 'heart', label: 'Heart', icon: Heart },
  { value: 'briefcase', label: 'Briefcase', icon: Briefcase },
  { value: 'award', label: 'Award', icon: Award },
  { value: 'trophy', label: 'Trophy', icon: Trophy },
  { value: 'sparkles', label: 'Sparkles', icon: Sparkles },
  { value: 'crown', label: 'Crown', icon: Crown },
  { value: 'gem', label: 'Gem', icon: Gem },
  { value: 'party', label: 'Party', icon: PartyPopper },
  { value: 'coffee', label: 'Coffee', icon: Coffee },
  { value: 'music', label: 'Music', icon: Music },
  { value: 'dumbbell', label: 'Activity', icon: Dumbbell },
  { value: 'book-open', label: 'Book', icon: BookOpen },
  { value: 'users', label: 'People', icon: Users },
  { value: 'calendar', label: 'Calendar', icon: CalendarDays },
  { value: 'megaphone', label: 'Announce', icon: Megaphone },
  { value: 'flag', label: 'Flag', icon: Flag },
  { value: 'zap', label: 'Energy', icon: Zap },
  { value: 'flame', label: 'Fire', icon: Flame },
];

export const getEventIconComponent = (iconName: string): LucideIcon => {
  const found = EVENT_ICON_OPTIONS.find(opt => opt.value === iconName);
  return found?.icon || PartyPopper;
};
